import * as $ from 'jquery';
import 'bootstrap';
import 'slick';

export class bannerSection{
    private bannerSectionDesktop: any = $('#banner-section');
    private isAnimationCompleted: any = false;
    private ResponsiveView: any = [
        {breakpoint: 1024, slide: 3, min:600},
        {breakpoint: 600, slide: 2, min:480},
        {breakpoint: 480, slide: 1, min:0}
    ]
    scrollAnimation(){
        

            $(document).on('scroll',function(){
                let scrollTop = $(this).scrollTop();
                let scrollNone = 0;
                let bannerSectionPosition:any=$('#banner-section').position().top;
                let bannerSectionHeight:any = $('#mh-explorer-section #banner-section .banner-section .col-xs-12').innerHeight();
                 if( scrollTop <= bannerSectionPosition )
                  
                 {
                    
                    $(".wave-one, .wave-two, .ellipse-image, .half-cut-orange, .bulb,.leaf-one,.leaf-two,.speaker ").removeClass('scroll-animation');
                }
                else{
                    
                    $(".wave-one, .wave-two, .ellipse-image, .half-cut-orange, .bulb,.leaf-one,.leaf-two,.speaker ").addClass('scroll-animation');
                }
             
                  });
                
            
        }
    
    
}
let scope:Element = document.querySelector('#banner-section');
if(scope){
    try{
        let banner = new bannerSection();
        banner.scrollAnimation();
    }catch(e) {console.error(e);}
}
